module.exports = __webpack_public_path__ + "assets/img/kv-e651f255.png";